import { Flex } from 'antd';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import surface from '@/styles/page-surface.module.scss';
import styles from './not-found.module.scss';
import { Button } from '@/components/button/button';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      className={clsx(surface.pageSurface, styles.centered)}
    >
      <h1>404</h1>
      <h2>{t('notFound.title')}</h2>
      <Flex vertical gap={16}>
        <Link className={styles.link} to="/">
          {t('notFound.backHome')}
        </Link>

        <Button className={styles.link} onClick={() => navigate(-1)}>
          {t('notFound.backPrevious')}
        </Button>
      </Flex>
    </Flex>
  );
}
